var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.521 7H16.2292C11.132 7 7 11.132 7 16.2292V108.521C7 113.618 11.132 117.75 16.2292 117.75H108.521C113.618 117.75 117.75 113.618 117.75 108.521V16.2292C117.75 11.132 113.618 7 108.521 7Z",
    stroke: "#333333",
    strokeWidth: 12.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6806 7L7 74.6806M117.75 50.0694L50.0694 117.75M111.597 13.1528L13.1528 111.597M25.4583 56.2222L46.9931 77.7569M77.7569 46.9931L99.2917 68.5278",
    stroke: "#333333",
    strokeWidth: 12.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor);
export default __webpack_public_path__ + "static/media/floor.33e4f6ddfbaa0473f5d0ce4a9bfa8e39.svg";
export { ForwardRef as ReactComponent };